import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { startWithEmptyList } from './startWithEmptyList';

/**
 * Combines two observables pairing the elements from the first
 * observable with the corresponding elements from the second (if they exist)
 * indexed by id.
 */
export function combineWithLatestItem<
  T,
  S extends { readonly id: T[P] },
  P extends keyof T,
>(
  ys$: Observable<readonly S[]>,
  property: P,
): (
  source$: Observable<readonly T[]>,
) => Observable<readonly (readonly [T, S | undefined])[]> {
  return xs$ =>
    combineLatest([xs$, ys$.pipe(startWithEmptyList())]).pipe(
      map(([xs, ys]) => xs.map(x => [x, ys.find(y => y.id === x[property])])),
    );
}
